<mat-card appearance="outlined" [formGroup]="loginForm" class="login-card border-0 shadow-sm p-3 p-sm-4">
  
  <mat-card-header class="d-flex flex-column-reverse align-items-center mb-4 p-0">
    <div class="brand-logo-wrapper mb-3 shadow-sm rounded-circle p-2 bg-white">
      <img class="brand-logo-img" src="sygma.png" alt="Sygma Logo">
    </div>
    <mat-card-title class="fs-5 fw-bold text-dark text-uppercase tracking-wide m-0">
      Connexion
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="d-flex flex-column gap-2 p-0">
    
    <mat-form-field  class="w-100 custom-login-field mt-3">
      <mat-label class="text-muted">Username</mat-label>
      <input matInput type="text" formControlName="username" placeholder="Entrez votre login">
      <mat-icon matSuffix class="text-muted">account_circle</mat-icon>
      @if (loginForm.get('username')?.hasError('required')) {
        <mat-error>nom d'utilisateur requis</mat-error>
      }
    </mat-form-field>

    <mat-form-field  class="w-100 custom-login-field mt-1">
      <mat-label class="text-muted">Password</mat-label>
      <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" (keydown.enter)="doLogin()" placeholder="Entrez votre password">
      <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword; $event.stopPropagation()" aria-label="Afficher/Masquer le mot de passe">
        <mat-icon class="text-muted">{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
      @if (loginForm.get('password')?.hasError('required')) {
        <mat-error>mot de passe requis</mat-error>
      }
    </mat-form-field>

  </mat-card-content>

  <div class="d-flex justify-content-center my-2">
    <button mat-button (click)="openForgetPassword()" class="forgot-password-link small text-decoration-none fw-medium text-white">mot de passe oublié</button>
  </div>

  <mat-card-actions class="p-0 d-flex justify-content-center">
    @if(loading()){
      <div class="d-flex align-items-center gap-2 py-2">
        <mat-spinner diameter="24" color="primary"></mat-spinner>
        <span class="text-muted small fw-medium">connexion ...</span>
      </div>
    } @else {
      <button color="primary" mat-flat-button class="w-100 py-2 btn-login fw-semibold" (click)="doLogin()" [disabled]="loginForm.invalid">
        Envoyer
      </button>
    }
  </mat-card-actions>
</mat-card>
